import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import PropTypes from "prop-types";
import React from "react";
import { appendClassName } from "./view-helpers";

function PagingInfo(_ref) {
  var className = _ref.className,
      end = _ref.end,
      searchTerm = _ref.searchTerm,
      start = _ref.start,
      totalResults = _ref.totalResults,
      rest = _objectWithoutProperties(_ref, ["className", "end", "searchTerm", "start", "totalResults"]);

  return (
    /*#__PURE__*/
    React.createElement("div", _extends({
      className: appendClassName("sui-paging-info", className)
    }, rest), "Showing", " ",
    /*#__PURE__*/
    React.createElement("strong", null, start, " - ", end), " ", "out of ",
    /*#__PURE__*/
    React.createElement("strong", null, totalResults), searchTerm &&
    /*#__PURE__*/
    React.createElement(React.Fragment, null, " ", "for: ",
    /*#__PURE__*/
    React.createElement("em", null, searchTerm)))
  );
}

PagingInfo.propTypes = {
  end: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired,
  className: PropTypes.string
};
export default PagingInfo;